var _desc, _defs, _rect, _path, _path2, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuroraMigrationFlowMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 1160",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "RDS\uC5D0\uC11C Aurora\uB85C \uC804\uD658\uD558\uB294 \uB370\uC774\uD130\uBCA0\uC774\uC2A4 \uB9C8\uC774\uADF8\uB808\uC774\uC158 \uD750\uB984") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "\uAE30\uC874 RDS\uC758 \uBCC0\uACBD \uB370\uC774\uD130\uB97C CDC\uB85C \uBCF5\uC81C\uD574 Writer\uC640 Reader \uAD6C\uC870\uC758 Aurora\uB85C \uC804\uD658\uD558\uB294 \uC138\uB85C\uD615 \uC138 \uB2E8\uACC4 \uD750\uB984")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arrow",
    viewBox: "0 0 10 10",
    refX: 9,
    refY: 5,
    markerWidth: 8,
    markerHeight: 8,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L10 5 L0 10Z",
    fill: "#43a9df"
  })), /*#__PURE__*/React.createElement("style", null, "\n      text { font-family: Pretendard, \"Apple SD Gothic Neo\", \"Noto Sans KR\", sans-serif; }\n      .label { fill: #26384b; font-size: 48px; font-weight: 800; letter-spacing: -0.5px; }\n      .label-accent { fill: #1377ad; font-size: 48px; font-weight: 800; letter-spacing: -0.5px; }\n      .caption { fill: #748396; font-size: 32px; font-weight: 650; }\n      .caption-accent { fill: #3689b5; font-size: 32px; font-weight: 700; }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 1160,
    rx: 38,
    fill: "#fbfcfd"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400 330 V422",
    fill: "none",
    stroke: "#c9d5de",
    strokeWidth: 7,
    strokeLinecap: "round",
    markerEnd: "url(#arrow)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M400 690 V782",
    fill: "none",
    stroke: "#8bcbed",
    strokeWidth: 7,
    strokeLinecap: "round",
    markerEnd: "url(#arrow)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 400,
    cy: 128,
    rx: 96,
    ry: 30,
    fill: "#e7ecf1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 128 V240 C304 258 347 272 400 272 C453 272 496 258 496 240 V128",
    fill: "#f2f5f7",
    stroke: "#d4dde5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 400,
    cy: 128,
    rx: 96,
    ry: 30,
    fill: "#f7f9fa",
    stroke: "#d4dde5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 184 C304 202 347 216 400 216 C453 216 496 202 496 184",
    fill: "none",
    stroke: "#dce4ea",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 326,
    textAnchor: "middle",
    className: "label"
  }, "\uAE30\uC874 RDS"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 368,
    textAnchor: "middle",
    className: "caption"
  }, "\uB2E8\uC77C DB"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 540,
    r: 106,
    fill: "#ffffff",
    stroke: "#b9def1",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354,
    cy: 540,
    r: 12,
    fill: "#a7d7ef"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 540,
    r: 12,
    fill: "#69bce6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 446,
    cy: 540,
    r: 12,
    fill: "#2f9bd3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344 510 C372 480 428 480 456 510",
    fill: "none",
    stroke: "#cfe8f5",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344 570 C372 600 428 600 456 570",
    fill: "none",
    stroke: "#cfe8f5",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 694,
    textAnchor: "middle",
    className: "label"
  }, "CDC \uBCF5\uC81C"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 736,
    textAnchor: "middle",
    className: "caption"
  }, "Binlog \uAE30\uC900"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 900,
    r: 112,
    fill: "#e8f6fd",
    stroke: "#8ccfee",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 882,
    r: 46,
    fill: "#ffffff",
    stroke: "#56b2df",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436,
    cy: 854,
    r: 36,
    fill: "#ffffff",
    stroke: "#8ccfee",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 938,
    r: 40,
    fill: "#ffffff",
    stroke: "#8ccfee",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394 882 L402 882 M384 898 L410 924 M422 890 L430 900",
    stroke: "#56b2df",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 1062,
    textAnchor: "middle",
    className: "label-accent"
  }, "Aurora"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 1104,
    textAnchor: "middle",
    className: "caption-accent"
  }, "Writer \xB7 Reader"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuroraMigrationFlowMobile);
export default __webpack_public_path__ + "static/media/aurora-migration-flow-mobile.24f00e0b1f94ae66091c97b64e282444.svg";
export { ForwardRef as ReactComponent };